import {useEffect} from 'react';
import {sendMessageToGame} from '@/services/internal/sdk/sdk';

/*
    Below are three functions to monitor memory usage on the client side.

    The first function uses the performance.memory API to check memory usage,
    this is supported in most modern browsers, and runs every second.

    The second function listens for the webkitmemorypressure event, which is
    triggered when the browser detects high memory usage, and is supported in
    WebKit browsers.

    This useEffect also adds event listeners to the window object to listen for
    messages from the iframe.
  */

export const useMemoryObserver = () => {
  useEffect(() => {
    const monitorMemoryUsage = () => {
      //@ts-ignore
      if (performance.memory) {
        //@ts-ignore
        const usedMemory = performance.memory.usedJSHeapSize;
        //@ts-ignore
        const totalMemory = performance.memory.jsHeapSizeLimit;
        const memoryUsage = (usedMemory / totalMemory) * 100;

        if (memoryUsage > 80) {
          console.debug(`Memory usage: ${memoryUsage.toFixed(2)}%`);
          console.warn('High memory usage detected, consider freeing resources.');
          // Free resources or notify the game to handle memory
          sendMessageToGame('OnReceivedMemoryWarning');
        } else {
          console.debug(`Memory usage: ${memoryUsage.toFixed(2)}%`);
        }
      }
    };

    const handleMemoryPressure = (_e: Event) => {
      console.debug('Memory pressure event detected:', _e);
      alert('Memory pressure detected, freeing up resources...');
      //@ts-ignore
      if (performance.memory) {
        //@ts-ignore
        const memoryUsage = performance.memory.usedJSHeapSize;
        //@ts-ignore
        const memoryLimit = performance.memory.jsHeapSizeLimit;

        console.debug(
          `Memory pressure detected: ${memoryUsage} bytes used out of ${memoryLimit} bytes`
        );
      } else {
        console.debug('Memory pressure detected, but performance.memory is not available.');
      }

      // Call your function to free up resources
      sendMessageToGame('OnReceivedMemoryWarning');
    };

    const memoryObserverInterval = setInterval(monitorMemoryUsage, 1000); // Check memory every 1 second
    window.addEventListener('webkitmemorypressure', handleMemoryPressure);

    return () => {
      window.removeEventListener('webkitmemorypressure', handleMemoryPressure);
      clearInterval(memoryObserverInterval);
    };
  }, []);
};
